"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaGroupAdapter = exports.TextAreaGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextAreaGroup = require("../TextAreaGroup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TextAreaGroup = function TextAreaGroup(_ref) {
  var atts = _ref.atts,
      input = _ref.input,
      meta = _ref.meta,
      label = _ref.label,
      cashbotName = _ref.cashbotName,
      isPlastic = _ref.isPlastic,
      counterAriaLabel = _ref.counterAriaLabel,
      isRequiredField = _ref.isRequiredField,
      doFocus = _ref.doFocus;

  var fieldAttributes = _objectSpread({}, input, atts);

  return _react.default.createElement(_TextAreaGroup.TextAreaGroup, {
    fieldName: input.name,
    value: input.value,
    atts: fieldAttributes,
    label: label,
    cashbotName: cashbotName,
    isPlastic: isPlastic,
    isInvalid: meta.invalid,
    isTouched: meta.touched,
    warningMessage: meta.warning,
    errorMessage: meta.error,
    counterAriaLabel: counterAriaLabel,
    isRequiredField: isRequiredField,
    doFocus: doFocus
  });
};

exports.TextAreaGroup = TextAreaGroup;
TextAreaGroup.defaultProps = {
  isPlastic: false,
  isRequiredField: false,
  doFocus: false
};
TextAreaGroup.propTypes = {
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired
  }).isRequired,
  input: _propTypes.default.object.isRequired,
  meta: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isPlastic: _propTypes.default.bool,
  counterAriaLabel: _propTypes.default.func.isRequired,
  isRequiredField: _propTypes.default.bool,
  doFocus: _propTypes.default.bool
};
var TextAreaGroupAdapter = TextAreaGroup;
exports.TextAreaGroupAdapter = TextAreaGroupAdapter;